var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-root select-none"},[_c('div',{ref:"map-mapview",staticClass:"map"}),_c('div',{staticClass:"global-loading"},[_c('table',[_c('tr',[_c('td',[_c('span',{staticClass:"global-loading-text",domProps:{"innerHTML":_vm._s(_vm.loadingText)}})])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }